import clsx from 'clsx';

import styles from './Divider.module.scss';

type DividerProps = {
  vertical?: boolean;
  className?: string;
};

const Divider = ({ vertical, className }: DividerProps) => {
  return <div className={clsx(vertical ? styles.verticalDivider : styles.divider, className)} />;
};

export default Divider;
